// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-gsZ","content":"styles_content__3lOjF"};